import {createAction} from 'redux-actions'

export let runUploadImportOnIds = createAction('RUN_UPLOAD_IMPORT_ON_IDS', (txid, uploadids) => ({
  txid,
  uploadids,
}))
export let setUploadImportJob = createAction('SET_UPLOAD_IMPORT_JOB', (txid, ojid) => ({
  txid,
  ojid,
}))

export let analyzeUploadImportOnIds = createAction(
  'ANALYZE_UPLOAD_IMPORT_ON_IDS',
  (key, uploadids) => ({
    key,
    uploadids,
  })
)

export let setAnalyzedImport = createAction('SET_ANALYZED_IMPORT', (key, packages) => ({
  key,
  packages,
}))
